import { useState } from "react";
import axios from "axios";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const LEVELS = [
  { id: "simple", label: "Simpel", hint: "Korte zinnen, geen jargon" },
  { id: "standard", label: "Standaard", hint: "Originele weergave" },
  { id: "deep", label: "Diep", hint: "Analytische verdieping" },
];

export const CommunicationLevelToggle = ({ discussionId, originalSynthesis, onChange }) => {
  const [activeLevel, setActiveLevel] = useState("standard");
  const [loadingLevel, setLoadingLevel] = useState(null);
  const [cache, setCache] = useState({ standard: originalSynthesis });

  const apply = async (level) => {
    if (level === activeLevel || loadingLevel) return;
    if (cache[level]) {
      setActiveLevel(level);
      onChange?.(cache[level], level);
      return;
    }
    setLoadingLevel(level);
    try {
      const res = await axios.post(`${API}/debate/${discussionId}/communication/${level}`);
      const next = res.data.synthesis;
      setCache((c) => ({ ...c, [level]: next }));
      setActiveLevel(level);
      onChange?.(next, level);
    } catch (err) {
      const msg = err?.response?.data?.detail || "Communicatieniveau kon niet worden gegenereerd.";
      toast.error(msg);
    } finally {
      setLoadingLevel(null);
    }
  };

  return (
    <div className="no-print flex items-center gap-2 mb-3" data-testid="communication-level-toggle">
      <Sparkles className="w-3 h-3 text-blue-400" />
      <span className="text-[10px] font-mono uppercase text-gray-400">Niveau:</span>
      <div className="flex border border-gray-700">
        {LEVELS.map((l) => (
          <button
            key={l.id}
            onClick={() => apply(l.id)}
            disabled={loadingLevel === l.id}
            title={l.hint}
            className={`px-2.5 py-1 text-[11px] font-bold transition-colors disabled:opacity-60 ${
              activeLevel === l.id ? "bg-blue-500 text-white" : "bg-transparent text-gray-300 hover:bg-gray-800"
            }`}
            data-testid={`comm-level-${l.id}`}
          >
            {loadingLevel === l.id ? <Loader2 className="w-3 h-3 animate-spin inline" /> : l.label}
          </button>
        ))}
      </div>
    </div>
  );
};
